import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@dm/core';
import { RemoveHomedirRuleCifsShareComponent } from './remove-homedir-rule-cifs-share.component';
@NgModule({
    declarations: [RemoveHomedirRuleCifsShareComponent],
    exports: [RemoveHomedirRuleCifsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
})
export class RemoveHomedirRuleCifsShareModule { }
